import { connect } from 'react-redux';
import { MarketplaceType } from 'utils/entities';
import { State } from 'store/state';
import { createSelector } from 'reselect';
import { residentialOfficeListingsSelector, commercialOfficeListingsSelector, officeListingsLoadingSelector } from 'store/state/domainData/selectors/officeListings';
import { OfficeListingsCarousel, OfficeListingsCarouselProps } from './carousel';

const listingsSelector = createSelector([
  residentialOfficeListingsSelector,
  commercialOfficeListingsSelector,
  (_: State, marketplace: MarketplaceType) => marketplace,
  (_: State, __: MarketplaceType, excludePoiId: string) => excludePoiId,
], (residential, commercial, marketplace, excludePoiId) => {
  switch (marketplace) {
    case MarketplaceType.Commercial:
      return commercial.filter(({ id }) => id !== excludePoiId).slice(0, 10);
    case MarketplaceType.Residential:
      return residential.filter(({ id }) => id !== excludePoiId).slice(0, 10);
    default:
      return [];
  }
});

const mapStateToProps = (state: State, props: Pick<OfficeListingsCarouselProps, 'marketplace' | 'excludePoiId'>) => ({
  isLoading: officeListingsLoadingSelector(state),
  listings: listingsSelector(state, props.marketplace, props.excludePoiId),
});

export default connect(mapStateToProps)(OfficeListingsCarousel);
